<template>
<standard-dialog v-model="visible" scrollable persistent>

  <template slot="title">
    <span class="title">{{$t('face.add_face')}}</span>
  </template>

  <v-select box hide-details v-model="selectedCamera" :items="camera" :label="$t('camera.select_camera')" :no-data-text="$t('camera.no_camera_available')">
    <template slot="item" slot-scope="data">
      <v-list-tile-content>
        <v-list-tile-title v-text="data.item.text"></v-list-tile-title>
        <v-list-tile-sub-title class="caption" v-text="data.item.value"></v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
  </v-select>

  <camera-thumb :src="imageUrl" :faces="faceDetails"></camera-thumb>

  <template slot="actions">
    <v-btn flat color="secondary" @click="refreshImage" v-if="selectedCamera" :loading="refreshing">
      <v-icon class="mr-1" dark>refresh</v-icon>
      <span class="hidden-xs-only">{{ $t('camera.refresh') }}</span>
    </v-btn>
    <v-spacer></v-spacer>
    <v-btn flat color="primary" @click="addFace" v-if="selectedCamera" :disabled="!canAddFace" :loading="adding">
      <v-icon class="mr-1" dark>face</v-icon>
      <span class="hidden-xs-only">{{ $t('face.add_face') }}</span>
    </v-btn>
  </template>

</standard-dialog>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import Dialog from '@/components/utils/Dialog'
import CameraThumb from './CameraThumb'

export default {
  name: 'FaceLabelingAddDialog',
  mixins: [UserAuth],
  components: {
    'standard-dialog': Dialog,
    'camera-thumb': CameraThumb
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    camera: {
      type: Array,
      required: true
    },
    shots: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.selectedCamera = (this.camera.find(v => v) || {}).value;
  },
  data() {
    return {
      imageUrl: undefined,
      selectedCamera: null,
      refreshing: false,
      adding: false,
    }
  },
  watch: {
    selectedShot(val) {
      this.refreshing = false;
      this.imageUrl = `${val.url}&${val.timestamp}`;
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    selectedShot() {
      if (this.selectedCamera) {
        return this.shots[this.selectedCamera] || {};
      }
    },
    faceDetails() {
      if (this.selectedCamera)
        return ((this.shots[this.selectedCamera] || {}).result || {}).FaceDetails;
    },
    canAddFace() {
      return (this.faceDetails || []).length == 1 && Object.keys(this.userFace || {}).length <= 10;
    }
  },
  methods: {
    addFace() {
      this.adding = true;
      let [mac, uid, cid] = this.selectedCamera.split('-');
      let cmd = {
        user: this.userId,
        mac: mac,
        uid: uid,
        cmd: 'add'
      };
      let ref = this.$db.ref('command/face').push();
      ref.set(cmd).catch(err => {
        this.adding = false;
        this.$emit('toast', err.message);
      });
      ref.on('child_added', snapshot => {
        switch (snapshot.key) {
          case 'result':
            ref.off();
            this.adding = false;
            let val = snapshot.val();
            if ((val.FaceRecords || []).length > 0) {
              setTimeout(() => {
                this.visible = false;
              }, 1000);
            } else {
              this.$emit('toast', this.$t('face.there_is_no_face'));
            }
            break;

          case 'error':
            ref.off();
            this.adding = false;
            this.$emit('toast', snapshot.val());
        }
      });
      setTimeout(() => {
        ref.off();
        this.adding = false;
      }, 10000);
    },
    refreshImage() {
      this.refreshing = true;
      let [mac, uid, cid] = this.selectedCamera.split('-');
      let cmd = {
        user: this.userId,
        mac: mac,
        uid: uid,
        cmd: 'snapshot',
        faceDetection: true
      };
      this.$db.ref('command/cast').push().set(cmd).catch(err => {
        this.refreshing = false;
        console.log(err.message);
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cast/FaceLabelingAddDialog.vue